import { Fragment, type FC } from 'react';
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import { Delete, MoreVert } from '@mui/icons-material';

export type AuditFormMechanicalEntryPageMenuProps = {
  onClose: () => void;
  onOpen: (event: HTMLElement) => void;

  isOpen: boolean;
  anchorEl: HTMLElement | null;

  onDelete: () => void;
  isDeleteDisabled: boolean;
};

export const AuditFormMechanicalEntryPageMenu: FC<
  AuditFormMechanicalEntryPageMenuProps
> = ({
  onClose,
  onOpen,

  isOpen,
  anchorEl,

  onDelete,
  isDeleteDisabled,
}) => (
  <Fragment>
    <IconButton
      color="inherit"
      aria-label="more"
      aria-controls={isOpen ? 'Audit menu' : undefined}
      aria-expanded={isOpen ? 'true' : undefined}
      aria-haspopup="true"
      onClick={(e) => onOpen(e.currentTarget)}>
      <MoreVert />
    </IconButton>
    <Menu anchorEl={anchorEl} open={isOpen} onClose={onClose}>
      <MenuItem onClick={onDelete} disabled={isDeleteDisabled}>
        <ListItemIcon>
          <Delete />
        </ListItemIcon>
        <ListItemText>Delete</ListItemText>
      </MenuItem>
    </Menu>
  </Fragment>
);
